import React, { Component } from 'react'
import core from './core'
// import axios from 'axios'
import Router from './Router'

const { Auth } = core.components
// const { getUserByEmail, getUserProfile } = core.helpers

class App extends Component {
  state = {
    snackbar: {
      open: false
    },
    menu: {
      open: false,
      anchorEl: null
    }
  }

  async componentWillMount() {
    console.log(process.env.REACT_APP_VERSION)
    let user = sessionStorage.getItem('user') || '' //'demo.user@effco.net' //'jbinda' //'Robert.Hussey' //'demo.user' // 'derek.finn' // 'tkostus' //
    if (process.env.REACT_APP_ENV !== 'local') {
      // const profile = await axios.get('/.auth/me')
      // const userId = profile.data[0] ? profile.data[0].user_id : `${user}@`
      // user = userId.split('@')[0]
    }

    // sessionStorage.setItem('user', '')
    sessionStorage.setItem('user', user)

    this.forceUpdate()
  }

  snackbar = (message = '', open = true) => {
    this.setState({ snackbar: { open: open, message } })
  }

  render() {
    if (sessionStorage.getItem('user') === '')
      return (
        <div
          style={{
            marginTop: 75,
            padding: 10
          }}
        >
          <Router
            header={core.components.Header}
            snackbar={this.snackbar.bind(this)}
          />
          <core.components.Snackbar
            {...this.state.snackbar}
            clear={() => this.snackbar('', false)}
          />
        </div>
      )

    return (
      <Auth app>
        {/* <core.components.Header /> */}
        <div
          style={{
            marginTop: 75,
            padding: 10
          }}
        >
          <Router
            header={core.components.Header}
            snackbar={this.snackbar.bind(this)}
          />
        </div>
        <core.components.Snackbar
          {...this.state.snackbar}
          clear={() => this.snackbar('', false)}
        />
      </Auth>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js